import { ProvidersGetRequestParams } from "@lib/core";

export interface ProviderDefaultParams extends ProvidersGetRequestParams { }
export class ProviderDefaultParams {
  constructor() {
    this.select = "*,\
      devices(id)";
    this.order = "id.asc";
  }
}